<template>
  <div class="main center">
    <div class="banner" v-if="!this.$Request['ct']">
      <ul class="gameList center-space-between">
        <li class="item" v-for="gameId in gameList" v-bind:key="gameId">
          <img :src="require('../img/game/img_bg'+ gameListName[gameId-1] +'.png')">
        </li>
      </ul>
      <div class="gameMask"></div>
    </div>
    <div class="main-box">
      <div class="top-main " v-if="this.$Request['ct']">
        <div class="icon-redeem center-space-between">
          <div class="icon-left">
            <img src="../img/skin/logo_837.png" alt="">
          </div>
          <div class="redeem-info center-flex-center">
            <img class="jt" src="../img/redeem.png">
            <div class="info center">
              <span class="win">Win</span>
<!--              <img class="bk" src="../img/bigIcon/img_LM.png">-->

              <img class="bk" :src="$ImgArr['big_'+$Request['typeName']]" :alt="$Request['typeName']">
            </div>
          </div>
          <div class="icon-right">
            <img :src="$ImgArr['ico_'+$Request['typeName']]" alt="">
          </div>
        </div>
        <div class="top-info">
          <span>Download and play [ {{$Request['app_name']}} ] to get more {{$Request['typeCoin']}}</span>
        </div>
      </div>

      <div class="center-box">
        <div class="center-bg"><img src="../img/center_bg.png"></div>
        <div class="top-icon center">
          <div class="share_title" :class="showLocale()">{{ $t('share_title') }}</div>
        </div>

        <div class="reward">
          <div class="reward-center">
            <div class="reward-info-box center">
<!--              <div class="reward-install-info" :class="showLocale()" v-html="$t('share_info').replace('{count}', ' ')"></div>-->
              <div class="reward-install-info" :class="showLocale()">You will receive a welcome {{$Request['typeCoin']}} of up to  </div>
            </div>
            <div class="reward-amount center" @click="testLanguage">
              <img class="coin" :src="$ImgArr['coin_'+$Request['typeName']]" :alt="$Request['typeName']">
              <span class="val">+{{ active_count }}</span>
            </div>
            <div class="reward-time">{{ countdownStr }}</div>
          </div>
        </div>
        <div class="btn-dow-pos btn-dow center btn-anim" @click="download">
          <span class="title">{{ $t('install_btn') }}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// 保存模块

let layer = require('layer-mobile');
export default {
  data() {
    return {
      json: {},
      isTest: '',
      countdown: 300,//5分钟
      countdownStr: '00:00:00',
      active_count: 6,
      productName: 'Disco Ball',
      productList: {
        210: "Diamond",
      },
      isAutoDow: true,
      isLoadings: false,
      cache_start_time: 0,
      cache_end_time: 0,
      languageIndex: 0,
      gameList: [
        4, 2, 3//默认
      ],
      gameListName: [
        'ML',   // = 1, //无尽对决-沐瞳
        'FF',   // = 2, //FreeFire-吃鸡
        'RB',   // = 3, //Roblox-VR
        'LOL',  // = 4, //英雄联盟
        'PM',   // = 5, //绝地求生-PUBG MOBILE
        'BS',   // = 6, //荒野乱斗-Brawl Stars
        'LM',   // = 7, //Lords Mobile:Tower Defense
        'CC',   // = 8, //Clash of Clans
        'CD',   // = 9, //Call of Duty: Mobile - Elite of the Elite
      ],
      gameListImg: {},
    }
  },
  name: 'Home',
  props: {
    msg: String
  },
  mounted() {
    let _this = this;
    this.initData();
    this.timer = setInterval(() => {
      _this.countdownStr = this.FormatTime(_this.countdown, "hh:mm:ss");
      _this.countdown--;
      if (_this.countdown < 0) {
        _this.countdown = 5 * 60;
      }
    }, 1000)
  },
  computed: {},
  beforeDestroy() {
    if (this.timer) {
      clearInterval(this.timer); // 在Vue实例销毁前，清除我们的定时器
    }
  },
  methods: {
    showLocale() {
      return this.$i18n.locale.substring(0, 2)
    },
    testLanguage() {
      if (this.isLog) {
        let list = [];
        for (const indexKey in this.$i18n.messages) {
          list.push(indexKey)
        }
        let index = this.languageIndex % list.length;
        this.$i18n.locale = list[index]
        this.languageIndex++;
      }
    },
    initData() {
      let self = this;
      let conf = this.$Request;
      if (conf === undefined) {
        self.layer('无参数', 3);
        return;
      }
      self.json = conf;
      console.log(self.json);
      self.TrackV2('s_h5');

      // 初始化名字
      let productName = self.productList[self.json.product_id];
      if (productName !== undefined) {
        self.productName = productName;
        if (this.isLog) {
          console.log('initData => 产品ID:', self.json.product_id);
        }
      }

      //增加name接口的内容
      let appName = self.json.app_name;
      if (typeof appName == "string" && appName.length > 0) {
        self.productName = appName;
        if (this.isLog) {
          console.log('initData => appName:', self.productName);
        }
      }

      //增加金额的内容
      let active_count = self.json.active_count;
      if (typeof active_count == "string" && appName.length > 0) {
        self.active_count = active_count;
        if (this.isLog) {
          console.log('initData => 金额:', self.active_count);
        }
      }

      //适配旧版游戏
      let gameList = self.json.gameList;
      if (typeof gameList === "object" && appName.length > 0) {
        self.gameList = gameList;
        if (this.isLog) {
          console.log('initData => 游戏列表:', self.gameList);
        }
      }
    },
    download() {
      this.TrackV2('c_h5_button');
      if (typeof this.json.url != "undefined") {
        window.location = this.json.url;
      }else{
        console.error('no download url');
      }
    },
    layer(content, time) {
      let self = this;
      if (isNaN(time)) {
        time = 2;
      }
      if (self.isTest) {
        console.log(content, time)
        //提示
        layer.open({content: '测试-' + content, skin: 'msg', time: time});
      }
    },

  }
}


</script>

<style scoped>

</style>
